import DeviceLogsPage from './device-logs-page';

export default DeviceLogsPage;